exports.linkResolver = function linkResolver(doc) {
   if (doc.type === 'post') return `/actualites/${doc.uid}`

   if (doc.type === 'case_study') return `/projets/${doc.uid}`

   if (doc.type === 'page') return `/${doc.uid}`

   return `/${doc.uid}`
 }